enum TemplateOptionsEnum {
    SK = "SK",
    CZ = "CZ"
}

export default TemplateOptionsEnum;
